import { useEffect, useState, useMemo } from "react"
import { fetchArtistsByIds } from "@/lib/tattooData"
import type { Artist } from "@/types/models"

export function useArtists(artistIds: string[]) {
  const [artists, setArtists] = useState<Artist[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)

  // Memoize the artistIds to prevent infinite re-renders
  const memoizedArtistIds = useMemo(() => artistIds, [artistIds.join(',')])

  useEffect(() => {
    if (memoizedArtistIds.length === 0) {
      setArtists([])
      setLoading(false)
      return
    }

    setLoading(true)
    fetchArtistsByIds(memoizedArtistIds)
      .then(setArtists)
      .catch(err => {
        console.error("Failed to load artists", err)
        setError(err)
      })
      .finally(() => setLoading(false))
  }, [memoizedArtistIds])

  return { artists, loading, error }
} 